// extracted by mini-css-extract-plugin
export default {"font-renta":"ToolsPageHeader_font-renta__anIvB","headerStyles":"ToolsPageHeader_headerStyles__IMYVM"};